import { FETCH_DRIVERS_TABLE, RECEIVE_DRIVERS_TABLE, FAILED_DRIVERS_TABLE,
        FETCH_DRIVERS_SUMMARY, RECEIVE_DRIVERS_SUMMARY, FAILED_DRIVERS_SUMMARY,
        FETCH_DRIVER_FLEETS, RECEIVE_DRIVER_FLEETS, FAILED_DRIVER_FLEETS
} from '../../actions/transporter/aTransporter-DriversTable'

const defaultDriversTableState = {
    driversTableData: [],
    totalDriver: 0, 
    success: false,
}

export function fetchDriversTable(state = defaultDriversTableState, action){
    switch (action.type) {
        case FETCH_DRIVERS_TABLE:
            return ({driversTableData: [], totalDriver: 0, success: false, inProgress: true})
        case RECEIVE_DRIVERS_TABLE:
            var _totalDriver = action.payload.result.length
            return Object.assign({}, state, {driversTableData: action.payload, totalDriver: _totalDriver, success: true, inProgress: false})
        case FAILED_DRIVERS_TABLE:
            return ({driversTableData: [], totalDriver: 0, success: false, inProgress: false})
        default:
            return state
    }
}

const defaultDriversSummaryState = {
    driversSummaryData: [],
    loading: null,
}

export function fetchDriversSummary(state = defaultDriversSummaryState, action){
    switch (action.type) {
        case FETCH_DRIVERS_SUMMARY:
            return ({driversSummaryData: [], totalDriver: 0, loading: "loading"})
        case RECEIVE_DRIVERS_SUMMARY:
            const {payload} = action
            return Object.assign({}, state, {driversSummaryData: payload, loading: "loaded"})
        case FAILED_DRIVERS_SUMMARY:
            return ({driversSummaryData: [], totalDriver: 0, loading: "error"})
        default:
            return state
    }
}

const defaultDriverFleetsState = {
    driverFleetsData: [],
    loading: null,
}

export function fetchDriverFleets(state = defaultDriverFleetsState, action){
    switch (action.type) {
        case FETCH_DRIVER_FLEETS:
            return ({driverFleetsData: [], loading: "loading"})
        case RECEIVE_DRIVER_FLEETS:
            const {payload} = action
            return Object.assign({}, state, {driverFleetsData: payload.result, loading: "loaded"})
        case FAILED_DRIVER_FLEETS:
            return ({driverFleetsData: [], loading: "error"})
        default:
            return state
    }
}